import { render, staticRenderFns } from "./AntiCorruptionMeasuresDetail.vue?vue&type=template&id=67ad21ea&scoped=true&"
import script from "./AntiCorruptionMeasuresDetail.vue?vue&type=script&lang=js&"
export * from "./AntiCorruptionMeasuresDetail.vue?vue&type=script&lang=js&"
import style0 from "./AntiCorruptionMeasuresDetail.vue?vue&type=style&index=0&id=67ad21ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad21ea",
  null
  
)

export default component.exports